/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function Caret({ large = false, ...props }) {
  if (large) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        css={{
          ...css`
            color: #3722d3;
            cursor: pointer;
          `,
          ...(props.css ? props.css : {}),
        }}
        {...props}
      >
        <path
          d="M9.97447 11.2018L18 22.7076L26.0255 11.2018"
          stroke="#3722D3"
          strokeWidth="2.5"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      css={{
        ...css`
          color: #3722d3;
          cursor: pointer;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <path
        d="M20.4866 14.2865L17 19.2851L13.5134 14.2865"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}

Caret.propTypes = {
  css: PropTypes.instanceOf(css),
};
